<template>
  <BaseCard>
    <Flex
      justify="between"
      :direction="$screen === 's' ? 'column' : 'row'"
    >
      <Flex direction="column">
        <BaseHeading>
          {{ $t('marketing.discounts.dynamic_pricing.title') }}
        </BaseHeading>
        <BaseText>
          {{ $t('marketing.discounts.dynamic_pricing.body') }}
        </BaseText>
        <BaseToggle
          v-model="toggleValue"
          :label="$t('marketing.discounts.dynamic_pricing.enable')"
          v-test="'enable-dynamic-pricing'"
        />
        <Flex v-show="toggleValue">
          <BaseButton
            :routerLink="{ name: 'calendar' }"
            color="inverted"
            @click="calenderBtnCliked"
            v-test="'go-to-calendar'"
          >
            {{ $t('global.actions.go_to_calendar') }}
          </BaseButton>
        </Flex>
      </Flex>
      <Flex>
        <img src="/img/marketing/dynamic-pricing.svg">
      </Flex>
    </Flex>
  </BaseCard>
</template>

<script lang="ts">
import { mapState, storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { flash } from '@/helpers/ui';
import { useCalendarFiltersStore } from '@/stores/calendar-filters';
import { useCompanyStore } from '@/stores/company';

export default defineComponent({
  setup() {
    const { dynamicPricingMode } = storeToRefs(useCalendarFiltersStore());
    return {
      dynamicPricingMode,
    };
  },
  computed: {
    ...mapState(useCompanyStore, ['companySettings', 'updateCompany']),
    toggleValue: {
      get() {
        return this.companySettings.bookings?.dynamicPricingEnabled || false;
      },
      set(value) {
        const input = {
          settings: {
            bookings: {
              dynamicPricingEnabled: value,
            },
          },
        };

        if (!value) {
          this.dynamicPricingMode = false;
        }

        this.updateCompany(input).then(() => {
          flash(
            this.$t(
              `global.flash.dynamic_pricing_${value ? 'enabled' : 'disabled'}`,
            ),
          );
        });
      },
    },
  },
  methods: {
    calenderBtnCliked() {
      this.dynamicPricingMode = true;
    },
  },
});
</script>
